import { FormControlLabel, Switch } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import axios, { isAxiosError } from "axios"
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react"
import { ImCross } from "react-icons/im"
import { RxHamburgerMenu } from "react-icons/rx";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom"
import Swal from "sweetalert2"
import Loadingwrapper from "../../component/LoadingWrapper"
import { HeadersRanking, AllBrandsOnLeaderboard } from "../../constants"
import GroupTrend from "./GroupTrend"

const V2Leaderboard = () => {

  const [searchParams, setSearchParams] = useSearchParams()
  const [page, setPage] = useState(1)
  const [groupTrends, setGroupTrends] = useState([])
  const [showGeography, setShowGeography] = useState(false)
  const [showSort, setShowSort] = useState(false)
  const [showSource, setShowSource] = useState(false)
  const [showBrand, setShowBrands] = useState(false)
  const [showTimeframe, setShowTimeframe] = useState(false)
  const [showPieCharts, setShowPieCharts] = useState(false)
  const [startDateValue, setStartDateValue] = useState(null)
  const [demandForecastType, setDemandForecastType] = useState("99% depth")
  const [salesTarget, setSalesTarget] = useState(100000)
  const publishDate = useRef(new Date().toDateString())
  const [loading, setLoading] = useState(false)
  const [brandCounts, setBrandCounts] = useState([])
  const [totalRetailerImages, setTotalRetailerImages] = useState(0)
  const [ShowCategoryOptions, setShowCategoryOptions] = useState(false)
  const [isDemandForecast, setIsDemandForecast] = useState(false)
  const [groupTrends45days, setGroupTrends45days] = useState([])
  useEffect(() => {
    if (searchParams.get('demandforecast') == 'true') {
      setIsDemandForecast(true)
    } else {
      setIsDemandForecast(false)
    }
  }, [searchParams.get('demandforecast')])

  const userLoggedIn = useSelector(state => state.userLoggedIn)

  useEffect(() => {
    if (showGeography) {
      setShowCategoryOptions(false)
      setShowSort(false)
      setShowBrands(false)
      setShowSource(false)
      setShowTimeframe(false)
    }
  }, [showGeography])
  useEffect(() => {
    if (showSort) {
      setShowCategoryOptions(false)
      setShowBrands(false)
      setShowSource(false)
      setShowTimeframe(false)
      setShowGeography(false)
    }
  }, [showSort])
  useEffect(() => {
    if (showBrand) {
      setShowCategoryOptions(false)
      setShowSort(false)
      setShowSource(false)
      setShowTimeframe(false)
      setShowGeography(false)
    }
  }, [showBrand])
  useEffect(() => {
    if (showSource) {
      setShowCategoryOptions(false)
      setShowSort(false)
      setShowBrands(false)
      setShowTimeframe(false)
      setShowGeography(false)
    }
  }, [showSource])
  useEffect(() => {
    if (showTimeframe) {
      setShowCategoryOptions(false)
      setShowSort(false)
      setShowBrands(false)
      setShowSource(false)
      setShowGeography(false)
    }
  }, [showTimeframe])
  useEffect(() => {
    if (ShowCategoryOptions) {
      setShowSort(false)
      setShowBrands(false)
      setShowSource(false)
      setShowTimeframe(false)
      setShowGeography(false)
    }
  }, [ShowCategoryOptions])



  useEffect(() => {
    axios.get(`/social-trends-v2-api/leaderboard-brand-images-count?gender=${searchParams.get('gender') || 'Female'}&category=${searchParams.get('category').split('&').join('%26')}${searchParams.get('tag') ? `&tag=${encodeURIComponent(searchParams.get('tag'))}` : ''}${searchParams.get('value') ? `&value=${encodeURIComponent(searchParams.get('value'))}` : ''}&time=${searchParams.get('time')}`).then(resp => {
      setBrandCounts(resp.data.brandCounts)
      let totalCounts = 0;
      resp.data.brandCounts.forEach(t => {
        totalCounts = totalCounts + t.count;
      })
      setTotalRetailerImages(totalCounts)
    })
  }, [searchParams.get('gender'), searchParams.get('category'), searchParams.get('time')])

  useEffect(() => {
    setSearchParams(prev => {
      prev.set('time', prev.has('time') ? prev.get('time') : '15 days')
      prev.set('geography', prev.has('geography') ? prev.get('geography') : 'All')
      prev.set('source', prev.has('source') ? prev.get('source') : '')
      prev.set('sort', prev.get('gender') == 'Male' ? 'depth' : prev.has('sort') ? prev.get('sort') : 'social')
      return prev
    })
  }, [])

  const get45daysOldTrends = async (signal) => {
    const day45Date = new Date(new Date().getTime() - 45 * 1000 * 24 * 3600)
    try {
      const resp = await axios.get(`/social-trends-v2-api/leaderboard-trends?gender=${searchParams.get('gender') || 'Female'}&category=${searchParams.get('category').split('&').join('%26')}&geography=${searchParams.get('geography') || 'All'}&source=${searchParams.get('source') || ''}&time=${searchParams.get('time') || '30 days'}&page=${page || 1}&limit=${searchParams.get('limit') || 50}${searchParams.get('tag') ? `&tag=${searchParams.get('tag').split('&').join('%26')}` : ''}&value=${encodeURIComponent(searchParams.get('value'))}&sort=${searchParams.get('sort') || ''}${searchParams.get('brand') ? `&brand=${encodeURIComponent(searchParams.get('brand'))}` : ''}&startDate=${dayjs(day45Date).format('DD-MM-YYYY')}`, { signal })
      const newGroupTrends = {}
      resp.data.trendGroups.forEach(trendGroup => {

        newGroupTrends[trendGroup.tag] = trendGroup
      })
      setGroupTrends45days(newGroupTrends)
    } catch (e) {
      if (!isAxiosError(e))
        console.log(e)
    }
  }

  useEffect(() => {
    if (!isDemandForecast) {
      return
    }
    const abortController = new AbortController();
    const signal = abortController.signal;
    try {
      get45daysOldTrends(signal)
    } catch (e) {
      console.error(e)
    }
    return () => {
      abortController.abort()
    }
  }, [searchParams, startDateValue, isDemandForecast])

  const getTrends = async (signal) => {
    setLoading(true)
    setGroupTrends([])
    try {
      const resp = await axios.get(`/social-trends-v2-api/leaderboard-trends?gender=${searchParams.get('gender') || 'Female'}&category=${searchParams.get('category').split('&').join('%26')}&geography=${searchParams.get('geography') || 'All'}&source=${searchParams.get('source') || ''}&time=${searchParams.get('time') || '30 days'}&page=${page || 1}&limit=${searchParams.get('limit') || 50}${searchParams.get('tag') ? `&tag=${searchParams.get('tag').split('&').join('%26')}` : ''}&value=${encodeURIComponent(searchParams.get('value'))}&sort=${searchParams.get('sort') || ''}${searchParams.get('brand') ? `&brand=${encodeURIComponent(searchParams.get('brand'))}` : ''}${startDateValue ? `&startDate=${dayjs(startDateValue).format('DD-MM-YYYY')}` : ''}`, { signal })
      setLoading(false)
      const newGroupTrends = resp.data.trendGroups.sort((a, b) => {
        if (isDemandForecast) {
          if (a.tag == 'COLOR') return 1;
          if (b.tag == 'COLOR') return -1;
        }
        if (HeadersRanking[searchParams.get('category')]) {
          return HeadersRanking[searchParams.get('category')][a.tag] - HeadersRanking[searchParams.get('category')][b.tag]
        }
        return 1
      })
      setGroupTrends(newGroupTrends)
    } catch (e) {
      if (!isAxiosError(e))
        console.log(e)
    }
  }
  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    try {
      getTrends(signal)
    } catch (e) {
      console.error(e)
    }
    return () => {
      abortController.abort()
    }
  }, [searchParams, startDateValue])

  useEffect(() => {
    setSearchParams(prev => {
      if (searchParams.has('tag')) {
        prev.set('time', '60 days')
      } else {
        let timeframe = '15 days'
        if (searchParams.get('category') == 'Ethinic Wear')
          timeframe = '60 days'
        else if (searchParams.get('gender') == 'Male')
          timeframe = '30 days'
        prev.set('time', timeframe)
      }
      return prev
    })

  }, [searchParams.get('tag'), searchParams.get('value')])

  return <div>
    <div className="py-2 bg-black sticky top-10 z-[60] ">
      <p className="text-white text-center text-2xl">TRENDS IN {searchParams.get('gender') == 'Female' ? 'WOMEN' : 'MALE'} {'>'} {searchParams.get('category')} {searchParams.get('tag') ? <>{'>'} <span className="text-red-400"> <span className="font-semibold">{searchParams.get('value') != '#N/A' ? searchParams.get('value') : 'No Specific'}</span>  ({searchParams.get('tag')})<button onClick={() => {
        setSearchParams(prev => {
          prev.delete('tag')
          prev.delete('value')
          return prev
        })
      }}><ImCross size={16} /></button>
      </span>
      </> : null}</p>

      <div className="group absolute ml-2 top-0 left-0">
        <div className="rounded cursor-pointer text-3xl group-hover:bg-slate-700 p-2" onClick={() => { setShowCategoryOptions(prev => { console.log(prev); return !prev; }) }}>
          <RxHamburgerMenu height={40} color="white"></RxHamburgerMenu>
        </div>
        {groupTrends.length > 0 ? <div className={`${ShowCategoryOptions ? 'block' : 'hidden'} group-hover:block absolute top-[90%] left-0 bg-slate-700 not-italic rounded px-3 z-50 text-white`}>
          <div className="w-40 p-2 flex flex-col">
            {
              groupTrends
                .filter(a => (a.socialTrends && a.socialTrends.length > 0) || (a.retailerTrends && a.retailerTrends.length > 0))
                .filter(a => (searchParams.get('category') != 'Ethinic Wear' || ["ETHINIC WEAR", "NECKLINE", "KURTA SILHOUETTE", "COLOR"].includes(a.tag)))
                .map((gr, index) => <div className="hover:underline font-semibold">
                  <a key={gr.tag} href={"#" + gr.tag}  >{gr.tag}</a>
                </div>)
            }
          </div>
        </div> : null}
      </div>
    </div>
    {isDemandForecast ? <div className="flex px-4 py-2 text-sm">
      <p className="text-medium ">Enter {searchParams.get('category')} sales target for next 2 months</p>
      <input
        className="px-2 mx-2 border-b outline-none focus:bg-slate-50 focus:border w-40"
        value={`${salesTarget}`}
        type='text'
        onChange={(e) => {
          const newString = e.target.value.trim();
          if (newString == '') {
            setSalesTarget(0)
          }
          if (isNaN(parseInt(newString)))
            return
          setSalesTarget(parseInt(newString))

        }}
      />
    </div> : null}
    {!isDemandForecast ? <div className="py-2 flex bg-gray-600 text-white justify-between flex-wrap lg:flex-nowrap lg:w-screen z-20">
      <div className="flex flex-wrap lg:flex-nowrap">
        {false &&
          <div className="mx-6 w-52 relative " onMouseEnter={() => { setShowSource(true) }} onMouseLeave={() => setShowSource(false)}>
            <div className="w-full text-nowrap overflow-hidden">Channel : {!searchParams.get('source') || searchParams.get('source') == '' ? 'All' : `${searchParams.get('source').split(',')[0]}${searchParams.get('source').split(',').length > 1 ? `(+ ${searchParams.get('source').split(',').length - 1})` : ''} `}          </div>
            {showSource && <div className="absolute w-full left-0 py-2 bg-gray-600 text-[10px] text-wrap">

              {['All', 'Mega Influencers', 'Micro Influencers', 'Celebrities', 'Pages/Magazines', 'Stores/Brands']
                .map(t => <button
                  key={t}
                  className={`mx-2 ${(searchParams.get('source') || '').split(',').includes(t) || (searchParams.get('source') == '' && t == 'All') ? 'font-semibold underline' : ''} w-full text-left px-4 py-1`}
                  onClick={() => {
                    setSearchParams(prev => {
                      let newVal = prev.get('source');
                      if (t == 'All') {
                        newVal = ''
                      } else {
                        if (newVal.includes(t)) {
                          newVal = newVal.split(',').filter((item) => item != t).join(',')

                        } else {
                          newVal = newVal == '' ? t : newVal + ',' + t
                        }
                      }
                      if (newVal.split(',').length == 5) {
                        newVal = ''
                      }
                      prev.set('source', newVal);
                      return prev
                    })
                  }}
                >{t}</button>)}
            </div>}
          </div>
        }
        <div className="mx-6 relative" onMouseEnter={() => { setShowSort(true) }} onMouseLeave={() => setShowSort(false)} onClick={() => setShowSort(prev => !prev)}>

          <div className="w-40 shrink-0 overflow-hidden">Sort: {searchParams.get('sort') == 'depth' ? 'Depth' :
            searchParams.get('sort') == 'rog' ? 'Rate Of Growth' :
              searchParams.get('sort') == 'social' ? 'Rising vs. Dominant (Social)' :
                searchParams.get('sort') == 'retailer' ? 'Rising vs. Dominant (retailer)' :
                  'Social by RoG + Retailer by Depth'} </div>
          {showSort && <div className="absolute w-full left-0 py-2 bg-gray-600 text-[10px] text-wrap max-h-96 overflow-y-auto z-20">

            <button
              className={` ${(searchParams.get('sort') == 'social') ? 'font-semibold underline' : ''} w-full text-left px-2 py-1`}
              onClick={() => {
                setSearchParams(prev => {
                  prev.set('sort', 'social');
                  return prev
                })
              }
              }
            >Rising Vs. Dominant (Social)</button>
            <button
              className={` ${(searchParams.get('sort') == 'retailer') ? 'font-semibold underline' : ''} w-full text-left px-2 py-1`}
              onClick={() => {
                setSearchParams(prev => {
                  prev.set('sort', 'retailer');
                  return prev
                })
              }
              }
            >Rising vs. Dominant (Retailer)</button>
            <button
              className={` ${(searchParams.get('sort') == 'rog') ? 'font-semibold underline' : ''} w-full text-left px-2 py-1`}
              onClick={() => {
                setSearchParams(prev => {
                  prev.set('sort', 'rog');
                  return prev
                })
              }
              }
            >Rate Of Growth</button>
            <button
              className={` ${(searchParams.get('sort') == 'depth') ? 'font-semibold underline' : ''} w-full text-left px-2 py-1`}
              onClick={() => {
                setSearchParams(prev => {
                  prev.set('sort', 'depth');
                  return prev
                })
              }
              }
            >Depth</button>
            <button
              className={` ${(searchParams.get('sort') == 'both') ? 'font-semibold underline' : ''} w-full text-left px-2 py-1`}
              onClick={() => {
                setSearchParams(prev => {
                  prev.set('sort', 'both');
                  return prev
                })
              }
              }
            >Social by RoG + Retailer by Depth</button>
          </div>}

        </div>
        <div className="mx-6 relative" onMouseEnter={() => { setShowTimeframe(true) }} onMouseLeave={() => setShowTimeframe(false)} onClick={() => setShowTimeframe(prev => !prev)}>

          <div className="w-full text-nowrap overflow-hidden">Trending in : Past {searchParams.get('time')} </div>

          {showTimeframe && <div className="absolute w-full left-0 py-2 bg-gray-600 text-[10px] text-wrap text-left z-20">
            {['7 days', '15 days', '30 days', '60 days', '90 days', '180 days']
              .map(t => <button
                key={t}
                className='mx-2 disabled:font-semibold disabled:underline w-full'
                disabled={t == searchParams.get('time')}
                onClick={() => {
                  setSearchParams(prev => {
                    prev.set('time', t);
                    return prev
                  })
                }}
              >{t}</button>)}
          </div>}
        </div>
        <div className="mx-6 relative" onMouseEnter={() => { setShowGeography(true) }} onMouseLeave={() => setShowGeography(false)} onClick={() => {
          setShowGeography(prev => !prev)
        }}>
          <div className="w-full text-nowrap overflow-hidden">Geography: {searchParams.get('geography')} </div>
          {showGeography && <div className="absolute w-full left-0 py-2 bg-gray-600 text-[10px] text-wrap z-20">

            {['All', 'Western', 'Asian', 'Indian'].map(t => <button
              key={t}
              className={`mx-2 ${(searchParams.get('geography') == t) ? 'font-semibold underline' : ''} w-full text-left px-4 py-1`}
              onClick={() => {
                setSearchParams(prev => {
                  prev.set('geography', t);
                  return prev
                })
              }}
            >{t}</button>)}
          </div>}
        </div>
      </div>

      {!showPieCharts ? <div className="mx-6 relative" onMouseEnter={() => { setShowBrands(true) }} onMouseLeave={() => setShowBrands(false)} onClick={() => { setShowBrands(prev => !prev) }}>

        <div className="w-40 shrink-0 overflow-hidden">Brand: {searchParams.get('brand') || 'All'} </div>
        {showBrand && <div className="absolute w-full left-0 py-2 bg-gray-600 text-[10px] text-wrap max-h-96 overflow-y-auto">
          <button
            className={`mx-2 ${(!searchParams.get('brand')) ? 'font-semibold underline' : ''} w-full text-left px-4 py-1`}
            onClick={() => {
              setSearchParams(prev => {
                prev.delete('brand');
                return prev
              })
            }}
          >All({totalRetailerImages})</button>

          {
            brandCounts.map(t => <button
              key={t.brand}
              className={`mx-2 ${(searchParams.get('brand') == t.brand) ? 'font-semibold underline' : ''} w-full text-left px-4 py-1`}
              onClick={() => {
                setSearchParams(prev => {
                  prev.set('brand', t.brand);
                  return prev
                })
              }
              }
            >{t.brand}({t.count})</button>)
          }
        </div>}

      </div> : null}
      <div className="mx-2 relative flex flex-wrap" >
        <div className="flex">
          <FormControlLabel
            value="end"
            control={<Switch
              value="check"
              selected={showPieCharts}
              className="p-0 border-none"
              size="medium"
              color="white"
              onChange={() => setShowPieCharts((prevSelected) => !prevSelected)}
            />}
            label="45-Day-Forecast"
            labelPlacement="end"
          />
          {
            showPieCharts ?
              <>
                <div className="flex items-center mr-2">
                  <select value={demandForecastType} onChange={(e) => {
                    setDemandForecastType(e.target.value)
                  }}
                    className="h-10 text-white bg-slate-500/0 border border-slate-700 rounded p-1 "
                  >{
                      ["Actual", "99% depth"].map(v => <option value={v}>{v == '99% depth' ? `${v} (recommended)` : v}</option>)
                    }
                    {
                      userLoggedIn.curator ? <>
                        {Array(21).fill().map((j, i) => <option value={0.90 + parseFloat(i) * 0.005}>{90 + parseFloat(i) * 0.5} Depth</option>)}
                      </> : null
                    }
                  </select>
                </div>
                {!isDemandForecast ? <div>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        label="Start Date"
                        format='DD-MM-YYYY'
                        value={startDateValue}
                        onChange={(newValue) => setStartDateValue(newValue)}
                        disableFuture
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div> : null}
              </> : null}
        </div>

      </div>

      <div className="px-10 italic text-[12px] font-normal hidden lg:flex">

        <a
          href={`/design-recipe-images?gender=${searchParams.get('gender') == 'Male' ? 'M' : 'F'}&category=${encodeURIComponent(searchParams.get('category'))}&time=180+days&geography=All&tab=both&sort=recency&page=1`}
          className='relative -top-0.5 px-2 mr-1 hover:bg-yellow-700 bg-yellow-600 py-1 rounded  font-semibold not-italic'
          target='_blank'
          rel="noreferrer"
        >All Images</a>
        <a
          href={`/build-designs?gender=${searchParams.get('gender')}&category=${encodeURIComponent(searchParams.get('category'))}`}
          className='relative -top-0.5 px-2 mr-1 hover:bg-red-700 bg-red-600 py-1 rounded  font-semibold not-italic'
          hidden={searchParams.get('category') == 'Ethinic Wear'}
          target='_blank'
          rel="noreferrer"
        >DESIGN BUILDER</a>
        <button onClick={() => {
          window.navigator.clipboard.writeText(window.location)
          Swal.fire({ title: "URL copied. ", timer: 1400, icon: 'success' })
        }}
          className='relative -top-0.5 px-2 mr-1 hover:bg-slate-900 py-1 rounded '
        >Share Leaderboard</button>
        <div>By FastFashionTrend.com on {publishDate.current}</div>

      </div>
    </div>
      : null}
    <Loadingwrapper loading={loading} className="pt-40">
      <div className="w-screen flex flex-wrap ">
        {groupTrends
          .filter(a => (a.socialTrends && a.socialTrends.length > 0) || (a.retailerTrends && a.retailerTrends.length > 0))
          .filter(a => (userLoggedIn.curator || searchParams.get('category') != 'Ethinic Wear' || ["ETHINIC WEAR", "NECKLINE", "KURTA SILHOUETTE", "COLOR"].includes(a.tag)))
          .map((gr, index) => <GroupTrend key={gr.tag} searchParams={searchParams} trendsData={gr} index={index} setSearchParams={setSearchParams} sort={searchParams.get('sort')} showPieCharts={showPieCharts} demandForecastType={demandForecastType} salesTarget={salesTarget} isDemandForecast={isDemandForecast} old45daysTrendsGroup={groupTrends45days[gr.tag] ? groupTrends45days[gr.tag] : {}} />)}

      </div>
    </Loadingwrapper>

  </div >
}

export default V2Leaderboard
